import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { AlertTriangle, LogOut } from 'lucide-react';

export function ImpersonationBanner() {
  const { impersonation, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!impersonation?.isImpersonating) {
    return null;
  }

  const handleExitImpersonation = async () => {
    try {
      await stopImpersonation();
      // Redirect back to admin users page
      navigate('/admin/users');
    } catch (error) {
      console.error('Failed to exit impersonation:', error);
    }
  };

  return (
    <div className="bg-amber-500 text-white py-2 px-4 md:sticky md:top-0 z-50 md:ml-[260px]">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5" />
          <span className="font-medium">
            Impersonating: {impersonation.resellerName}
          </span>
          <span className="text-amber-100 text-sm hidden sm:inline">
            (Admin: {impersonation.actorAdminEmail})
          </span>
        </div>
        <Button
          variant="secondary"
          size="sm"
          onClick={handleExitImpersonation}
          className="bg-white text-amber-600 hover:bg-amber-50 hover:text-amber-700"
        >
          <LogOut className="h-4 w-4 mr-2" />
          Exit Impersonation
        </Button>
      </div>
    </div>
  );
}
